export default __webpack_public_path__ + "static/media/telegram-white.22527ef9.svg";